const formInputSkinData = ['light', 'dark', 'muted'];

export default formInputSkinData;
